class WishlistNotification extends HHBaseElement {

    constructor() {
      super()
      this.stopPopupFocus = false
      this.open = this.open.bind(this)
      this.close = this.close.bind(this)
      this._show = this._show.bind(this)
      this._hide = this._hide.bind(this)
      this._handleDocumentClick = this._handleDocumentClick.bind(this)
      this.setPosition = this.setPosition.bind(this)
    }

    get duration() {
        return this.getAttribute('duration') ?? 3
    }

    get showMessage() {
        return this.getAttribute('show-message') ?? ''
    }

    get removeMessage() {
        return this.getAttribute('remove-message') ?? ''
    }

    connectedCallback() {
      this._attachListeners()
      this.setPosition()
    }

    disconnectedCallback() {
      this._removeListeners()
    }

    _handleDocumentClick(event) {
      if (this.contains(event.target)) {
        this.close()
      }
    }

    _handleDocumentKeydown(event) {
      if (event.key === 'Escape') {
        this.close()
      }
    }

    _attachListeners() {
      document.addEventListener('wishlist-notification::open', this.open)
      document.addEventListener('click', this._handleDocumentClick)
      document.addEventListener('keydown', this._handleDocumentKeydown.bind(this))
    }

    _removeListeners() {
      document.removeEventListener('wishlist-notification::open', this.open)
      document.removeEventListener('click', this._handleDocumentClick)
      document.addEventListener('keydown', this._handleDocumentKeydown.bind(this))
    }

    open(event) {

        if (event.detail.add && this.showMessage){
            this.textContent = this.showMessage
            this._show()
        } else if (this.removeMessage) {
            this.textContent = this.removeMessage
            this._show()
        }

        const period = this.duration * 1000
        if (this.timerId) {
            clearTimeout(this.timerId)
        }
        this.timerId = setTimeout(() => {
            this._hide()
        }, period);
    }

    get anchorElement() {
        return document.querySelector(this.getAttribute('anchor'))
    }

    setPosition() {
        try {
            const bounds = this.anchorElement.getBoundingClientRect()
            this.style.setProperty(
            '--wishlist-notification-anchor-offset-top',
            20 + bounds.top + bounds.height + 'px'
            )

            this.style.setProperty(
            '--wishlist-notification-anchor-offset-right',
            bounds.left + bounds.width * 2 + 'px'
            )
        } catch (error) {}
    }

    close() {
      this._hide()
    }

    _show() {
        this.setPosition()
        this.classList.add('active')
    }

    _hide() {
      this.classList.remove('active')
      this.textContent = ""
    }
}
window.customElements.define('wishlist-notification', WishlistNotification)
